import { connect } from 'react-redux'
import ConflictResolution from './conflict-resolution'
import { withMe } from 'pobble-components/dist/pobble-user'
import { fetchConflicts } from '../../../stores/conflict-resolution/conflict-resolution.actions'
import { getFetchRequest } from '../../../stores/conflict-resolution/conflict-resolution.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { me, meRequest }) => {
  return {
    schoolId:
      me &&
      !meRequest.pending &&
      me.account.teacher_type &&
      me.account.teacher_type.school &&
      me.account.teacher_type.school.id,
    pending: getFetchRequest(state).pending
  }
}

const mapDispatchToProps = (dispatch, { match }) => ({
  onMount: schoolId => dispatch(fetchConflicts(schoolId)).catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConflictResolution)
)
